import { Controller } from 'stimulus';
import {
  getYoutubeId,
  createYoutubeEmbed,
  getYoutubePoster,
  getVimeoId,
  createVimeoEmbed,
  getVimeoPoster,
  getEmbedType,
} from '../helpers/video';

const hasPoster = (target) => !!target.style.backgroundImage;

class Video extends Controller {
  connect() {
    this.addPosters();
  }

  onPosterClick(e) {
    e.preventDefault();

    this.element.insertAdjacentHTML('beforeend', this.getEmbed());
    this.element.classList.add('is-loaded');

    setTimeout(() => {
      this.element.classList.add('is-playing');
    }, 400);
  }

  getEmbed() {
    const source = this.data.get('src');
    let embed;

    if (getEmbedType(source) === 'youtube') {
      const id = getYoutubeId(source);
      embed = createYoutubeEmbed(id);
    } else if (getEmbedType(source) === 'vimeo') {
      const id = getVimeoId(source);
      embed = createVimeoEmbed(id);
    }

    return embed;
  }

  addPosters() {
    const source = this.data.get('src');

    if (hasPoster(this.posterTarget)) {
      return;
    }

    if (getEmbedType(source) === 'youtube') {
      this.addYoutubePoster(getYoutubeId(source));
    } else if (getEmbedType(source) === 'vimeo') {
      this.addVimeoPoster(getVimeoId(source));
    }
  }

  addYoutubePoster(id) {
    this.addVideoPoster(getYoutubePoster(id));
  }

  addVimeoPoster(id) {
    getVimeoPoster(id, (src) => {
      this.addVideoPoster(src);
    });
  }

  addVideoPoster(poster) {
    this.posterTarget.style.backgroundImage = `url(${poster})`;
  }
}

Video.targets = [
  'poster',
];

export default Video;
